const initialState = {
    status: false,
    basicquestions: [],
    mediahistory:[],
    msg:'',
    emailSent: null,
    mainSettings: {
      title: '',
      consent1: '',
      consent2: '',
      title_en: '',
      title_es: '',
      consent1_en: '',
      consent1_es: '',
      consent2_en: '',
      consent2_es: ''
    }
  }
  const client = (state = initialState, action) => {
    switch (action.type) {
      case "CONSENT_FORM": {
        return { 
          ...state,  
          status: action.data.status,
          bodyarea: action.data.bodyarea, 
          basicquestions: action.data.basicquestions, 
          mediahistory: action.data.mediahistory, 
          service: action.data.service, 
          userId: action.data.userId,
          mainSettings: action.data.mainSettings || state.mainSettings
        }
      }
      case "SUBMIT_CONSENT_FORM": {
        return { ...state,  status: action.data.status,emailSent: action.data.emailSent}
      }
      default: {
        return state
      }
    }
  }

  export default client
